import { render, staticRenderFns } from "./tab.vue?vue&type=template&id=96c40614"
import script from "./tab.vue?vue&type=script&lang=ts"
export * from "./tab.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports